module.exports = __webpack_public_path__ + "img/rz-logo-1.53ca2f30.svg";